module.exports = __webpack_public_path__ + "img/mi-speaker-notes.332f6cbd.svg";